<box>
  <app-header [title]="'ship_interface.select_supply_item' | transloco" [hasBottomBorder]="false" [hasBackButton]="true" (back)="onBack()" />

  <app-body>
    <app-header class="w-full" type="search" [control]="searchControl" />

    <app-single-selection
      [control]="getFormControl"
      [options]="filteredInventoryItems()"
      displayName="name"
      [unit]="'ship_interface.unit' | transloco"
      description="unit"
      (selectionChange)="selectInventoryItem($event)"
      selectionType="id" />
  </app-body>

  <app-footer
    [onDiscard]="onReset"
    [discardButtonTitle]="'button.reset' | transloco"
    [hasTopBorder]="false"
    [onSave]="null"
    [hasSaveButton]="['monthly_rob_ship_interface', ['update']] | permission"
    (save)="onSave()" />
</box>
